import React, { useState } from "react";
import { Typography, Box, IconButton, Collapse } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { BaseToolResult } from "./BaseToolResult";

interface GenericToolResultProps {
  toolName: string;
  result: any;
}

export const GenericToolResult: React.FC<GenericToolResultProps> = ({
  toolName,
  result,
}) => {
  const [expanded, setExpanded] = useState(false);
  
  // Format the tool name for display (convert snake_case to Title Case)
  const displayName = toolName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return (
    <BaseToolResult icon="🔧">
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton
            size="small"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
          <Typography variant="subtitle2" color="text.secondary">
            {displayName}
          </Typography>
        </Box>
        <Collapse in={expanded}>
          <Typography
            variant="body2"
            sx={{ 
              fontFamily: "monospace", 
              whiteSpace: "pre-wrap",
              bgcolor: "grey.50",
              p: 1,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.200",
              mt: 1
            }}
          >
            {JSON.stringify(result, null, 2)}
          </Typography>
        </Collapse>
      </Box>
    </BaseToolResult>
  );
};